import { Field } from "formik";
import React from "react";


const PropertyType = ({ setFieldValue, errors, touched, values }) => {
  return (
    <>
      <div className="account-created-pop">
        <h3>Tell us a little more</h3>
        {/* <p>What kind of job is this?</p> */}

        {/* Is it for a Home or Business? */}
        <div>
          <label>What type of property is it?</label>
          <div className="radio-select-set">

            <label style={{cursor:"pointer"}}>
              <Field type="radio" name="propertyType" value="House" style={{cursor:"pointer"}} />
              House
            </label>
            <label style={{cursor:"pointer"}}>
              <Field type="radio" name="propertyType" value="Flat" style={{cursor:"pointer"}} />
              Flat
            </label>

            <label style={{cursor:"pointer"}}>
              <Field type="radio" name="propertyType" value="Office" style={{cursor:"pointer"}} />
              Office
            </label>
            <label style={{cursor:"pointer"}}>
              <Field type="radio" name="propertyType" value="Shop" style={{cursor:"pointer"}} />
              Shop
            </label>
            <label style={{cursor:"pointer"}}>
              <Field type="radio" name="propertyType" value="Other" style={{cursor:"pointer"}} />
              Other
            </label>
          </div>
          {touched.propertyType && errors.propertyType && (
            <div className="error-message">{errors.propertyType}</div>
          )}
        </div>
        
      </div>
    </>
  );
};

export default PropertyType;


